/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './style.scss';
const Appliants = ({ applications, onOpenAction }) => {
  const renderStatus = (item) => {
    if (item.status == 0)
      return <span className='wait-application'>Chờ xác nhận</span>;
    if (item.status == 1)
      return <span className='finish-application'>Hoàn thành</span>;
    if (item.status == 2)
      return <span className='cancel-application'>Hủy</span>;
  };
  return (
    <div className='appliants'>
      <h4 className='appliants__title'>Danh sách đăng ký sử dụng dịch vụ</h4>
      <div className='appliants__list'>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th style={{ width: '250px' }}>Đơn vị đăng ký</th>
              <th style={{ width: '150px' }}>MST</th>
              <th style={{ width: '150px' }}>Loại hình</th>
              <th style={{ width: '200px' }}>Email</th>
              <th style={{ width: '150px' }}>Số điện thoại</th>
              <th style={{ width: '300px' }}>Trạng thái</th>
              <th style={{ width: '150px' }}>Thao tác</th>
              <th style={{ width: '300px' }}>Ghi chú</th>
            </tr>
          </thead>
          <tbody>
            {applications &&
              applications.map((item) => {
                return (
                  <tr>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.tax_code}</td>
                    <td>
                      {item.appliant.personal == 1 ? 'Cá nhân' : 'Doanh nghiệp'}
                    </td>
                    <td>{item.appliant.email}</td>
                    <td>{item.appliant.phone_number}</td>
                    <td>{renderStatus(item)}</td>
                    <td>
                      {item.status == 0 && (
                        <a
                          style={{ cursor: 'pointer', color: '#ffffff' }}
                          className='flex-center btn btn-primary'
                          onClick={() => onOpenAction(item)}
                        >
                          Chỉnh sửa
                        </a>
                      )}
                    </td>
                    <td>{item.note}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Appliants;
